const ACTIONABLE_REVIEW_STATUSES = new Set([
  "submitted",
  "pending",
  "under_review",
  "in_review",
]);

function normalizeSubmissionStatus(value) {
  return String(value || "").trim().toLowerCase();
}

function getSubmissionReviewUiState(submission = null, { canReview = false } = {}) {
  const status = normalizeSubmissionStatus(submission?.status);

  if (["approved", "completed"].includes(status)) {
    return { kind: "resolved", label: "Approved", tone: "success" };
  }

  if (status === "revision_requested") {
    if (canReview) {
      return { kind: "approve_only", label: "Revision requested", tone: "warning" };
    }

    return { kind: "resolved", label: "Revision requested", tone: "warning" };
  }

  if (["rejected", "cancelled"].includes(status)) {
    return { kind: "resolved", label: "No review action available", tone: "default" };
  }

  if (canReview && ACTIONABLE_REVIEW_STATUSES.has(status || "submitted")) {
    return { kind: "actions", label: "Pending review", tone: "info" };
  }

  return { kind: "readonly", label: "Pending review", tone: "default" };
}

function submitApproveReview({ submission, onReviewSubmission }) {
  return onReviewSubmission?.(submission, "approved", "");
}

function validateRevisionNote(note) {
  const trimmed = String(note || "").trim();
  return trimmed ? trimmed : null;
}

async function submitRevisionReview({ submission, note, onReviewSubmission }) {
  const trimmedNote = validateRevisionNote(note);
  if (!trimmedNote) {
    return { ok: false, error: "Revision note is required." };
  }

  await onReviewSubmission?.(submission, "revision_requested", trimmedNote);
  return { ok: true, trimmedNote };
}

module.exports = {
  ACTIONABLE_REVIEW_STATUSES,
  normalizeSubmissionStatus,
  getSubmissionReviewUiState,
  submitApproveReview,
  validateRevisionNote,
  submitRevisionReview,
};
